// @ts-nocheck
import './styles.css'

import React, { useEffect, useState } from 'react'

const customerFeedbackImages = [
  'assets/images/customerFeedbacks/1.png',
  'assets/images/customerFeedbacks/2.png',
  'assets/images/customerFeedbacks/3.png',
  'assets/images/customerFeedbacks/4.png',
  'assets/images/customerFeedbacks/5.png',
  'assets/images/customerFeedbacks/6.png',
  'assets/images/customerFeedbacks/7.png',
]

const ProductIntroduction: React.FC = () => {
  const [shuffledImages, setShuffledImages] = useState<string[]>([])
  const [currentIndex, setCurrentIndex] = useState<number>(0)

  useEffect(() => {
    const shuffled = [...customerFeedbackImages].sort(() => Math.random() - 0.5)
    setShuffledImages(shuffled)
  }, [])

  useEffect(() => {
    if (shuffledImages.length === 0) return

    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % shuffledImages.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [shuffledImages.length])

  const handleImageClick = (index: number) => {
    window.open(shuffledImages[index], '_blank')
  }

  return (
    <div className="px-20px mt-30px">
      <div className="bg-gradient-to-r from-[#1e293b] to-[#0f172a] rounded-15px p-15px shadow-lg">
        <h1 className="text-primary text-2xl font-bold mb-20px text-center">韩语宝典</h1>
        <div className="text-white-secondary text-sm text-center mt-20px mb-30px italic">
          悄咪咪读韩语一个月，我拿到了心仪的外企 offer
        </div>
        <div className="flex justify-center mb-20px h-240px mb-40px">
          <img
            src="assets/images/mini-code-for-official-website.png"
            alt="微信小程序码"
            className="rounded-md shadow-md mx-auto"
          />
        </div>
        <div className="text-primary text-xl font-bold mb-15px">给韩语学习者的一封信</div>

        <div className="text-white mb-15px">同学，你好！</div>

        <div className="text-white-secondary mb-10px">
          你是否厌倦了市面上&ldquo;电商式&rdquo;的韩语学习 APP，在各种卖课的货架上浏览而不知所措？
        </div>

        <div className="text-white-secondary mb-10px">
          我们诚挚地邀请你来使用这款<span className="text-white font-medium">真诚的</span>、
          <span className="text-white font-medium">简洁的</span>、<span className="text-white font-medium">纯粹的</span>
          韩语学习小程序。
        </div>

        <div className="text-white-secondary mb-10px">
          我们特别定制了各行业、各场景的韩语口语交流学习素材，专注于帮助职场人士快速提升韩语口语能力，突破韩语面试障碍，助力升职加薪！
        </div>

        <div className="text-white mb-15px mt-20px font-medium">
          你要做的只是跟读，跟着最标准、最地道的口音大声朗读。
        </div>

        <div className="text-white mb-15px mt-20px font-medium">只要你勇于开口、坚持大声开口跟读：</div>

        <div className="flex items-center mb-10px">
          <div className="w-8px h-8px rounded-full bg-primary mr-10px"></div>
          <div className="text-white-secondary">就会习惯韩语这门语言的节奏和韵律。</div>
        </div>

        <div className="flex items-center mb-10px">
          <div className="w-8px h-8px rounded-full bg-primary mr-10px"></div>
          <div className="text-white-secondary">就能慢慢记住很多地道的韩语表达。</div>
        </div>

        <div className="flex items-center mb-10px">
          <div className="w-8px h-8px rounded-full bg-primary mr-10px"></div>
          <div className="text-white-secondary">就可以在韩语面试中打败 90% 的竞争者。</div>
        </div>

        <div className="text-white-secondary mb-15px mt-20px">
          <div className="text-white-secondary">让我们一起大声读韩语吧！</div>
        </div>

        <div className="flex flex-col items-end mb-10px mt-15px">
          <div className="text-white-secondary italic">—— 努力摆脱开口嘴瓢的 Steven</div>
          <div className="text-white-secondary italic">2025/2/28</div>
        </div>
      </div>

      {/* 用户评价 - 图片轮播版 */}
      <div className="bg-gradient-to-r from-[#1e293b] to-[#0f172a] rounded-15px mt-15px p-15px mb-40px shadow-lg">
        <div className="text-primary text-xl font-bold mb-15px">用户真实评价</div>

        <div className="bg-[#0f172a] rounded-10px p-15px overflow-hidden relative">
          {shuffledImages.length > 0 && (
            <div className="relative w-full flex flex-col items-center">
              <div
                className="w-full"
                style={{ maxHeight: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <img
                  src={shuffledImages[currentIndex]}
                  alt={`用户评价 ${currentIndex + 1}`}
                  className="rounded-md cursor-pointer transition-opacity duration-500"
                  onClick={() => handleImageClick(currentIndex)}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '400px',
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                  }}
                />
              </div>
              <div className="flex justify-center gap-2 mt-15px">
                {shuffledImages.map((_, index) => (
                  <div
                    key={index}
                    className={`w-8px h-8px rounded-full transition-all duration-300 ${
                      index === currentIndex ? 'bg-primary w-20px' : 'bg-gray-500'
                    }`}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductIntroduction
